import startCase from "lodash/startCase";
import toLower from "lodash/toLower";

import { useGetRolesNew } from "@vega-api/generated/auth-permission-v1/auth-permission-v1";
import { type RoleContext } from "@vega-api/generated/types/roleContext";
import { type RoleNew } from "@vega-api/generated/types/roleNew";
import { m } from "@vega-core/paraglide/messages";

export type RoleOption = {
  value: string | undefined;
  isEditable: boolean;
  description?: string;
  label: string;
};

export const useRolesForContext = (roleContext: RoleContext) => {
  const { data: roles, isLoading } = useGetRolesNew(
    { context: roleContext },
    {
      query: { select: (response) => response.data },
    },
  );

  const getRoleOptionsAsRoles = (addResetOption = false): RoleNew[] => {
    if (!roles) return [];

    const formattedRoles = roles.map(
      (role): RoleNew => ({
        ...role,
        name: startCase(toLower(role.name)),
      }),
    );

    if (addResetOption) {
      formattedRoles.unshift({
        id: "",
        name: m.userManagement_permissions_noAccess(),
        contexts: [],
        customizable: false,
        description: "",
        permissions: [],
      });
    }

    return formattedRoles;
  };

  const isValidRole = ({ id }: { id?: string }): boolean => {
    if (!roles) return false;

    const options = roles.map(
      (role): RoleOption => ({
        value: role.id,
        label: startCase(toLower(role.name)),
        description: role.description,
        isEditable: role.customizable,
      }),
    );

    return options.some((role) => role.value === id);
  };

  return {
    getRoleOptionsAsRoles,
    isValidRole,
    roles,
    isLoading,
  };
};
